let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eZCQI"), load("chivm"), load("jczTu")]).then(() => parcelRequire('bnpc5'));